class CollectionFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.filterData = [];
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    this.productGridId = 'CollectionProductGrid';
    this.filterFormsId = 'CollectionFiltersForm';
    this.searchTemplate = document.querySelector('body.template-search');
    this.collectionTemplate = document.querySelector('body.template-collection');
    this.sections = this.getSections();
    this.addDrawerAttributes = this.addDrawerAttributes.bind(this);

    function debounce(fn, wait) {
      let t;
      return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
      };
    }

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    this.querySelector('form').addEventListener('input', this.debouncedOnSubmit.bind(this));
    document.querySelector('[data-drawer-open-btn]').addEventListener('click', this.handleDrawerOpen.bind(this));
    document.querySelector('[data-drawer-close-btn]').addEventListener('click', this.handleDrawerClose.bind(this));
    const drawerOverlay = document.querySelector('[data-filtering-drawer-overlay]');
    if (drawerOverlay) drawerOverlay.addEventListener('click', this.handleDrawerClose.bind(this));
    window.addEventListener('resize', this.addDrawerAttributes);
    window.addEventListener('popstate', this.onHistoryChange.bind(this));

    this.addDrawerAttributes();
    this.bindActiveFacetButtonEvents();
    
    // Modified: Only apply dropdown blur for topbar, not sidebar
    this.onDropDownBlur();
  }

  onDropDownBlur() {
    // Skip this for sidebar filters - we want them always open
    const isSidebar = document.querySelector('.collection-filters__sidebar');
    if (isSidebar) return;
    
    const getDropDowns = document.querySelectorAll('details');

    for (let item of getDropDowns) {
      document.addEventListener('click', function (event) {
        var isClickInside = item.contains(event.target);

        if (!isClickInside) {
          item.removeAttribute('open');
        }
      });
    }
  }

  isHidden(el) {
    return (el.offsetParent === null)
  }

  addDrawerAttributes() {
    const filterDrawer = document.querySelector('collection-filtering-form');
    filterDrawer.removeAttribute('role');
    filterDrawer.removeAttribute('aria-modal');

    if (window.innerWidth < 991) {
      filterDrawer.setAttribute('role', 'dialog');
      filterDrawer.setAttribute('aria-modal', 'true');
    }
  }

  handleDrawerOpen(e) {
    e.target.setAttribute('tabIndex', '-1');
    document.body.classList.add('js-drawer-open-filter', 'js-drawer-open');
    this.trapFocus('main-collection-filters', true);
  }

  handleDrawerClose() {
    const filterBtn = document.querySelector('[data-drawer-open-btn]');
    document.body.classList.remove('js-drawer-open-filter', 'js-drawer-open');
    filterBtn.setAttribute('tabIndex', '0');
    filterBtn.focus();
  }

  trapFocus(slideout_id, is_initial_open) {
    const idString = `#${slideout_id}`;
    const menu = document.getElementById(slideout_id);
    const togglers = document.querySelectorAll('.facets__disclosure, .collection-filters__sort');
    const inputs = document.querySelectorAll(`${idString} input:not([type=hidden]), ${idString} button:not([tabindex="-1"]), ${idString} a:not([tabindex="-1"]), ${idString} textarea`);
    const firstInput = inputs[0];
    let lastInput;

    menu.addEventListener('keydown', function (e) {
      const getLastToggler = (togglers[togglers.length - 1]);
      const lastGroupCollapsed = !getLastToggler.hasAttribute('open');
      lastInput = lastGroupCollapsed ? getLastToggler : (inputs[inputs.length - 1]);

      if (e.code === 'Tab' && !e.shiftKey && document.activeElement == lastInput) {
        e.preventDefault();
        firstInput.focus();
      }

      if (e.code === 'Tab' && e.shiftKey && document.activeElement == firstInput) {
        e.preventDefault();
        lastInput.focus();
      }
    });
  }

  onSubmitHandler(event) {
    event.preventDefault();
    if (this.collectionTemplate) {
      const formData = new FormData(event.target.closest('form'));
      const searchParams = new URLSearchParams(formData).toString();
      this.renderPage(searchParams, event);
    } else if (this.searchTemplate) {
      const searchParamsInitial = new URLSearchParams(window.location.search);
      const activeTypes = document.querySelector('#page-type-input').value;
      const types = Array.from(activeTypes.split(','));
      const defaultTypes = document.querySelector('.search--header input[name="type"]');

      if (activeTypes == "") {
        const getInput = document.querySelector('#page-type-input');
        getInput.value = defaultTypes.value;
      }

      const formData = new FormData(event.target.closest('form'));
      formData.append('q', searchParamsInitial.get('q'));

      if (types.includes('article') && !types.includes('product') || types.includes('page') && !types.includes('product')) {
        const getInputs = document.querySelectorAll(`#${this.filterFormsId} input:not(#page-type-input)`);
        const getLabels = document.querySelectorAll(`#${this.filterFormsId} label:not(.collection-filters__label)`);

        for (let item of getInputs) {
          item.setAttribute('disabled', 'disabled');
        }

        for (let inputLabel of getLabels) {
          inputLabel.classList.add('facet-checkbox--disabled');
        }

        if (searchParamsInitial.has('filter.p.product_type')) {
          let newFormData = new URLSearchParams(window.location.search).toString();
          formData.delete('filter.p.product_type');
          this.renderPage(newFormData, event);
        }

        if (searchParamsInitial.has('filter.p.vendor')) {
          let newFormData = new URLSearchParams(window.location.search).toString();
          formData.delete('filter.p.vendor');
          this.renderPage(newFormData, event);
        }

        if (searchParamsInitial.has('filter.v.availability')) {
          let newFormData = new URLSearchParams(window.location.search).toString();
          formData.delete('filter.v.availability');
          this.renderPage(newFormData, event);
        }
      }

      const searchParams = new URLSearchParams(formData).toString();
      this.renderPage(searchParams, event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    event.currentTarget.setAttribute('loading', 'true');
    this.toggleActiveFacets();
    this.renderPage(new URL(event.currentTarget.href).searchParams.toString());
  }

  onHistoryChange(event) {
    const searchParams = event.state?.searchParams || '';
    this.renderPage(searchParams, null, false);
  }

  toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  renderPage(searchParams, event, updateURLHash = true) {
    document.querySelector(`#${this.productGridId}>div`).classList.add('loading');

    if (this.collectionTemplate) {
      // Fetch product grid
      const productSection = this.sections.find(s => s.id === this.productGridId);
      const productUrl = `${window.location.pathname}?section_id=${productSection.section}&${searchParams}`;
      
      // Fetch filter section (for active facets only)
      const filterSection = this.sections.find(s => s.id === this.filterFormsId);
      const filterUrl = `${window.location.pathname}?section_id=${filterSection.section}&${searchParams}`;

      // Fetch both in parallel
      Promise.all([
        fetch(productUrl).then(r => r.text()),
        fetch(filterUrl).then(r => r.text())
      ]).then(([productHtml, filterHtml]) => {
        this.renderProductGrid(productHtml);
        this.renderActiveFacetsOnly(filterHtml);
      });

    } else if (this.searchTemplate) {
      const searchParamsInitial = new URLSearchParams(window.location.search);
      const formData = new FormData(event?.target?.closest('form'));
      formData.append('q', searchParamsInitial.get('q'));
      const newSearchParams = new URLSearchParams(formData).toString();
      
      const productSection = this.sections.find(s => s.id === this.productGridId);
      const url = `${window.location.pathname}?section_id=${productSection.section}&${newSearchParams}`;
      
      fetch(url)
        .then(response => response.text())
        .then((responseText) => {
          this.renderProductGrid(responseText);
        });
    }

    if (updateURLHash) this.updateURLHash(searchParams);
  }

  renderProductGrid(html) {
  const innerHTML = new DOMParser()
    .parseFromString(html, 'text/html')
    .getElementById(this.productGridId).innerHTML;

  document.getElementById(this.productGridId).innerHTML = innerHTML;

  // Smooth scroll to top of product grid after filtering
  const productGrid = document.getElementById(this.productGridId);
  if (productGrid) {
    const headerOffset = 140; // Adjust based on your sticky header height
    const elementPosition = productGrid.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
    
    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth'
    });
  }

  const event = new CustomEvent('paginate');
  document.dispatchEvent(event);
}

  renderActiveFacetsOnly(html) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    
    // Only update the active facets pills, NOT the filter dropdowns
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = parsedHTML.querySelector(selector);
      const targetElement = document.querySelector(selector);
      if (activeFacetsElement && targetElement) {
        targetElement.innerHTML = activeFacetsElement.innerHTML;
      }
    });

    this.bindActiveFacetButtonEvents();
    this.toggleActiveFacets(false);
    
    // Keep filters open
    this.keepFiltersOpen();
  }

  keepFiltersOpen() {
    document.querySelectorAll('.collection-filters__sidebar .js-filter').forEach((details) => {
      details.setAttribute('open', '');
    });
  }

  bindActiveFacetButtonEvents() {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.addEventListener('click', this.onActiveFilterClick, { once: true });
    });
  }

  updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  getSections() {
    return [
      {
        id: this.productGridId,
        section: document.getElementById(this.productGridId).dataset.sectionId
      },
      {
        id: this.filterFormsId,
        section: document.getElementById('main-collection-filters').dataset.id
      }
    ]
  }
}

customElements.define('collection-filtering-form', CollectionFiltersForm);


class PriceRange extends HTMLElement {
  constructor() {
    super();
    
    this.minSlider = this.querySelector('.price-range-min');
    this.maxSlider = this.querySelector('.price-range-max');
    this.progress = this.querySelector('.price-range-progress');
    this.minDisplay = this.querySelector('.price-min-display');
    this.maxDisplay = this.querySelector('.price-max-display');
    this.minHidden = this.querySelector('.price-hidden-min');
    this.maxHidden = this.querySelector('.price-hidden-max');
    
    if (this.minSlider && this.maxSlider) {
      this.min = parseInt(this.minSlider.min);
      this.max = parseInt(this.minSlider.max);
      
      this.minSlider.addEventListener('input', this.onSliderInput.bind(this));
      this.maxSlider.addEventListener('input', this.onSliderInput.bind(this));
      this.minSlider.addEventListener('change', this.onSliderChange.bind(this));
      this.maxSlider.addEventListener('change', this.onSliderChange.bind(this));
      
      this.updateProgress();
    } else {
      this.querySelectorAll('input')
        .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));
      this.setMinAndMaxValues();
    }
  }

  onSliderInput(event) {
    const type = event.target.dataset.type;
    let minVal = parseInt(this.minSlider.value);
    let maxVal = parseInt(this.maxSlider.value);
    
    if (type === 'min' && minVal > maxVal) {
      this.minSlider.value = maxVal;
      minVal = maxVal;
    }
    if (type === 'max' && maxVal < minVal) {
      this.maxSlider.value = minVal;
      maxVal = minVal;
    }
    
    this.updateProgress();
    this.updateDisplayValues();
  }

  onSliderChange(event) {
    const minVal = parseInt(this.minSlider.value);
    const maxVal = parseInt(this.maxSlider.value);
    
    this.minHidden.value = minVal > this.min ? minVal : '';
    this.maxHidden.value = maxVal < this.max ? maxVal : '';
    
    const form = this.closest('form');
    if (form) {
      form.dispatchEvent(new Event('input', { bubbles: true }));
    }
  }

  updateProgress() {
    const minVal = parseInt(this.minSlider.value);
    const maxVal = parseInt(this.maxSlider.value);
    const leftPercent = ((minVal - this.min) / (this.max - this.min)) * 100;
    const rightPercent = ((maxVal - this.min) / (this.max - this.min)) * 100;
    
    this.progress.style.left = leftPercent + '%';
    this.progress.style.width = (rightPercent - leftPercent) + '%';
  }

  updateDisplayValues() {
    const minVal = parseInt(this.minSlider.value);
    const maxVal = parseInt(this.maxSlider.value);
    
    if (this.minDisplay) this.minDisplay.textContent = minVal;
    if (this.maxDisplay) this.maxDisplay.textContent = maxVal;
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input[type="number"]:not(.price-hidden-input)');
    if (inputs.length < 2) return;
    
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', '0');
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range-selector', PriceRange);


class PageType extends HTMLElement {
  constructor() {
    super()
    this.selector = document.querySelector('[data-page-type-selector]');
    this.selector.addEventListener('change', this.setValue);
  }

  setValue(e) {
    const selectedTypes = e.currentTarget.querySelectorAll('input:checked');
    const types = Array.from(selectedTypes).map(option => option.value).join(',');

    const typeInput = document.querySelector('#page-type-input');
    typeInput.value = types;

    const event = new Event('input');
    typeInput.closest('form').dispatchEvent(event);
  }
}

customElements.define('page-type-selector', PageType);


class NumericRangeSelector extends HTMLElement {
  constructor() {
    super();
    
    this.minSlider = this.querySelector('.numeric-range-min');
    this.maxSlider = this.querySelector('.numeric-range-max');
    this.progress = this.querySelector('.numeric-range-progress');
    this.minDisplay = this.querySelector('.numeric-min-display');
    this.maxDisplay = this.querySelector('.numeric-max-display');
    this.checkboxes = this.querySelectorAll('.numeric-range-checkboxes input[type="checkbox"]');
    
    if (this.minSlider && this.maxSlider) {
      this.min = parseFloat(this.minSlider.min);
      this.max = parseFloat(this.minSlider.max);
      
      // Initialize sliders to min/max if no active filters
      const hasActiveFilters = Array.from(this.checkboxes).some(cb => cb.checked);
      if (!hasActiveFilters) {
        this.minSlider.value = this.min;
        this.maxSlider.value = this.max;
      }
      
      this.minSlider.addEventListener('input', this.onSliderInput.bind(this));
      this.maxSlider.addEventListener('input', this.onSliderInput.bind(this));
      this.minSlider.addEventListener('change', this.onSliderChange.bind(this));
      this.maxSlider.addEventListener('change', this.onSliderChange.bind(this));
      
      this.updateProgress();
    }
  }

  onSliderInput(event) {
    const type = event.target.dataset.type;
    let minVal = parseFloat(this.minSlider.value);
    let maxVal = parseFloat(this.maxSlider.value);
    
    if (type === 'min' && minVal > maxVal) {
      this.minSlider.value = maxVal;
      minVal = maxVal;
    }
    if (type === 'max' && maxVal < minVal) {
      this.maxSlider.value = minVal;
      maxVal = minVal;
    }
    
    this.updateProgress();
    this.updateDisplayValues();
  }

  onSliderChange(event) {
    const minVal = parseFloat(this.minSlider.value);
    const maxVal = parseFloat(this.maxSlider.value);
    
    // Update checkboxes based on range
    this.checkboxes.forEach(checkbox => {
      const value = parseFloat(checkbox.dataset.numericValue);
      const shouldBeChecked = value >= minVal && value <= maxVal;
      
      // Only change if different to avoid unnecessary form submissions
      if (checkbox.checked !== shouldBeChecked) {
        checkbox.checked = shouldBeChecked;
      }
    });
    
    // Trigger the form's input event to submit filters
    const form = this.closest('form');
    if (form) {
      form.dispatchEvent(new Event('input', { bubbles: true }));
    }
  }

  updateProgress() {
  const minVal = parseFloat(this.minSlider.value);
  const maxVal = parseFloat(this.maxSlider.value);
  const leftPercent = ((minVal - this.min) / (this.max - this.min)) * 100;
  const rightPercent = ((maxVal - this.min) / (this.max - this.min)) * 100;
  
  this.progress.style.left = leftPercent + '%';
  this.progress.style.width = (rightPercent - leftPercent) + '%';
  
  // Also update display values when progress updates
  const minRounded = Math.round(minVal * 10) / 10;
  const maxRounded = Math.round(maxVal * 10) / 10;
  
  if (this.minDisplay) this.minDisplay.textContent = minRounded;
  if (this.maxDisplay) this.maxDisplay.textContent = maxRounded;
}

  updateDisplayValues() {
  const minVal = parseFloat(this.minSlider.value);
  const maxVal = parseFloat(this.maxSlider.value);
  
  // Round to 1 decimal place to avoid floating point issues
  const minRounded = Math.round(minVal * 10) / 10;
  const maxRounded = Math.round(maxVal * 10) / 10;
  
  if (this.minDisplay) this.minDisplay.textContent = minRounded;
  if (this.maxDisplay) this.maxDisplay.textContent = maxRounded;
}
}

customElements.define('numeric-range-selector', NumericRangeSelector);